// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__dtakg","title":"HeaderSimple_title__r7-zm"};